// dependencies imports ⇒
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { Drawer, Divider } from "@mui/material";
// assets and scss imports ⇒
import close_icon from "../../../assets/crossIcon.svg";
import "./scheduleFollowUpNewModel.scss";
// project file imports(UI components) ⇒
import Calendar from "../scheduleFollowUpModal/Calendar";
import DoctorAndResourceView from "../DoctorAndResourceView";
// const file imports(helper methods, etc) ⇒
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../Util/c2cApiHandler";
import { GET_DOCTOR_RESOURCE_LIST } from "../../FollowUpDashboardView/constants/apiConstants";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import { FOLLOWUP_REMINDER } from "./apiConstants";
import useIsMobile from "../../../Util/Helper/useIsMobile";
import { USER_ROLE } from "../../../Util/constants";
import { doctorResourcesDefaultColors } from "../../FollowUpDashboardView/constants";

const ScheduleFollowUpNewModal = ({
  doctorRole,
  showModalForScheduleFollowUp,
  setShowModalForScheduleFollowUp,
  appointment,
  followUpData,
  setOpenAlert,
  setAlertMsg,
  appointmentsApi,
}) => {
  // const declarations ⇒
  const [calenderDate, setCalenderDate] = useState();
  const [selectedClinicId, setSelectedClinicId] = useState("");
  const [doctorResourceList, setDoctorResourceList] = useState([]);
  const [resourceSelected, setResourceSelected] = useState(false);
  const [enableLeadsDashboard, setEnableLeadsDashboard] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [quoteAmount, setQuoteAmount] = useState("");
  const [tempDoc, setTempDoc] = useState([]);
  const [purpose, setPurpose] = useState();
  const doctorContext = useContext(DoctorContext);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const isMobile = useIsMobile();

  // let or var declarations ⇒

  // life cycle methods ⇒

  useEffect(() => {
    if (clinicId) {
      setSelectedClinicId(clinicId);
    }
  }, [clinicId]);

  useEffect(() => {
    if (enableLeadsDashboard) {
      setResourceSelected(true);
    } else {
      setResourceSelected(false);
    }
  }, [enableLeadsDashboard]);

  useEffect(() => {
    setPurpose(followUpData?.purpose);
  }, [followUpData]);

  useEffect(() => {
    if (followUpData?.quote === null) {
      const newResourceList = doctorResourceList.map((doctor) => {
        if (doctor?.doctorId === appointment?.doctor_id) {
          const hasInClinicFollowUp = doctor?.procedureList.some(
            (procedure) => procedure?.procedureName === "In-Clinic Follow-up"
          );
          const updatedProcedureList = doctor?.procedureList.map(
            (procedure) => {
              const isProcedureSelected =
                (hasInClinicFollowUp &&
                  procedure?.procedureName === "In-Clinic Follow-up") ||
                (!hasInClinicFollowUp &&
                  procedure?.procedureName ===
                    (appointment?.consultation_type !== "Procedure"
                      ? appointment?.consultation_type
                      : appointment?.procedure_name));
              return {
                ...procedure,
                selected: isProcedureSelected,
              };
            }
          );
          return {
            ...doctor,
            procedureList: updatedProcedureList,
            isExpanded: true,
          };
        }
        return doctor;
      });
      setDoctorResourceList(newResourceList);
    }
  }, [tempDoc]);

  useEffect(() => {
    let selectedResource = false;
    selectedResource =
      doctorResourceList?.some((item) =>
        item?.procedureList?.some((procedure) => procedure.selected)
      ) || false;

    setResourceSelected(selectedResource);
  }, [doctorResourceList]);

  useEffect(() => {
    setEnableLeadsDashboard(doctorContext?.enableLeadsDashboard);
  }, [doctorContext?.enableLeadsDashboard]);

  useEffect(() => {
    if (showModalForScheduleFollowUp) {
      getDoctorAndResourceListAPICall();
    }
  }, [showModalForScheduleFollowUp]);

  useEffect(() => {
    if (tempDoc?.length > 0 && followUpData?.quote?.length > 0) {
      const updatedList = [...tempDoc];
      const selectedProcedure = followUpData.quote.map(
        (data) => data?.procedure_id
      );
      updatedList.forEach((data) => {
        data.procedureList.forEach((procedure) => {
          procedure.selected = selectedProcedure.includes(
            procedure.procedureId
          );
        });
        data.selectAll = data.procedureList.every((vi) => vi.selected);
        data.isExpanded = data.procedureList.some((vi) => vi.selected);
      });

      setDoctorResourceList(updatedList);
      checkProcedureSelected(updatedList);
    }
  }, [tempDoc]);

  // API Calls ⇒

  const getDoctorAndResourceListAPICall = () => {
    let api = GET_DOCTOR_RESOURCE_LIST(
      selectedClinicId ? selectedClinicId : clinicId
    );
    const resData = c2cGetApiHandler(api); //Fetch API Data
    resData.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        let selectedProcedure = [];
        if (doctorResourceList?.length > 0) {
          doctorResourceList.forEach((doctorData) => {
            doctorData.procedureList.forEach((procedure) => {
              if (procedure?.selected) {
                selectedProcedure.push(procedure?.procedureId);
              }
            });
          });
        }
        const combinedData = Object.entries(res?.data?.data).map(
          ([doctorId, doctorInfo]) => {
            const procedureList = [
              ...doctorInfo?.consultations.map((consultation) => ({
                procedureName: consultation?.procedure_name,
                procedureId: consultation?.consultation_setting_id,
                selected: selectedProcedure.includes(
                  consultation?.consultation_setting_id
                ),
                fee: consultation?.fees ? consultation?.fees : 0,
                consultationType: consultation?.consultation_type,
                doctor_type: doctorInfo?.doctor_type,
              })),
              ...doctorInfo?.procedures.map((procedure) => ({
                procedureName: procedure?.procedure_name,
                procedureId: procedure?.procedure_setting_id,
                selected: selectedProcedure.includes(
                  procedure?.procedure_setting_id
                ),
                fee: procedure?.fees ? procedure?.fees : 0,
                consultationType: procedure?.consultation_type,
                doctor_type: doctorInfo?.doctor_type,
              })),
            ];
            const index = Math.floor(Math.random() * 6);

            return {
              doctorId: doctorId,
              doctorName: doctorInfo?.doctor_full_name,
              procedureList: procedureList,
              selectAll: procedureList.every((vi) => vi.selected),
              isExpanded: procedureList.some((vi) => vi.selected),
              initialsStyle: doctorResourcesDefaultColors[index],
            };
          }
        );
        if (
          doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
          doctorRole === USER_ROLE.RESOURCE_CONSULTANT
        ) {
          const filteredData = combinedData.filter((doctor) => {
            return doctor?.doctorId === userId;
          });
          setDoctorResourceList(filteredData);
        } else {
          setDoctorResourceList(combinedData);
        }
        setTempDoc(combinedData);
      }
    });
  };

  const date =
    followUpData?.FollowUp_Date === "None" ? null : followUpData?.FollowUp_Date;

  const refreshAppointmentsApi = () => {
    appointmentsApi();
  };

  const handleSubmit = async (flag) => {
    let selectedProcedures = [];
    doctorResourceList.forEach((doctor) => {
      const selected = doctor.procedureList.filter(
        (procedure) => procedure.selected
      );

      if (selected?.length > 0) {
        selected.forEach((data) => {
          selectedProcedures.push({
            procedure_id: data?.procedureId,
            consultation_type: data?.consultationType
              ? data?.consultationType
              : "",
            doctor_name: doctor?.doctorName,
            doctor_id: doctor.doctorId,
            procedure_name: data?.procedureName,
            procedure_fee: data?.fee,
            doctor_type: data?.doctor_type,
            is_followup_schedule: true,
          });
        });
      }
    });
    const payload = {
      id: appointment?.appointment_id,
      follow_up_date: date ? date : moment(calenderDate).format("YYYY-MM-DD"),
      purpose: purpose,
      quote: selectedProcedures,
      quote_amount: quoteAmount,
      enable_follow_up: enableLeadsDashboard,
    };
    const res = c2cPostApiHandler(FOLLOWUP_REMINDER, payload);

    if (res) {
      setOpenAlert(true);
      setAlertMsg("Follow Up Date Added Successfully");
      setTimeout(() => {
        setOpenAlert(false);
      }, 2000);

      refreshAppointmentsApi();
      setShowModalForScheduleFollowUp(false);
      setCalenderDate();
      setTempDoc([]);
      setDoctorResourceList([]);
    } else {
      setShowModalForScheduleFollowUp(false);
      refreshAppointmentsApi();
      setCalenderDate();
    }
  };

  // Helper methods ⇒

  const handeQuoteAmount = (amount) => {
    setQuoteAmount(amount);
  };

  const handlePurposeInputChange = (event) => {
    setPurpose(event.target.value);
  };

  const handleCloseScheduleFollowModel = () => {
    setShowModalForScheduleFollowUp(false);
    setCalenderDate();
    setShowNote(false);
  };

  const checkProcedureSelected = (list) => {
    const selectedResource = list?.some((item) =>
      item?.procedureList?.some((procedure) => procedure.selected)
    );
    setShowNote(!selectedResource);
  };

  const handleDoctorResourceList = (list) => {
    setDoctorResourceList([...list]);
    checkProcedureSelected([...list]);
  };

  // Create Ui ==>

  const titleSubtitleUi = (title, value) => (
    <div className="sfu-card-title-value">
      <div className="sfu-title">{title}</div>
      <div className="sfu-value">{value}</div>
    </div>
  );

  const apponimentDateUi = (title, value) => (
    <div className="sfu-appoinment-date">
      <div className="sfu-title">{title}</div>
      <div className="sfu-value">{value}</div>
    </div>
  );

  const scheduleFollowUpFooter = () => {
    return (
      <div className="sfu-button-wrapper">
        <button
          disabled={(!date && !calenderDate) || !resourceSelected}
          className="btn btn-sm primary-cta-button rounded-pill py-2 px-3 schedule-follow-up-button"
          onClick={() => handleSubmit(!date && calenderDate)}
        >
          Save
        </button>
      </div>
    );
  };

  const displayTextAreaUI = () => {
    return (
      <div className="sfu-textarea-container">
        <div className="sfu-title">Purpose of Follow-Up</div>
        <input
          className="sfu-textarea-input"
          placeholder="Type Purpose of Follow-Up"
          value={purpose}
          maxLength={500}
          onChange={(e) => handlePurposeInputChange(e)}
        />
      </div>
    );
  };

  const scheduleFollowUpPusposeProcedureUI = () => {
    return (
      <>
        {displayTextAreaUI()}

        <div className="sfu-procedure-wrapper">
          <DoctorAndResourceView
            showNote={showNote}
            doctorResourceList={doctorResourceList}
            setDoctorResourceList={handleDoctorResourceList}
            handeQuoteAmount={handeQuoteAmount}
          />
        </div>
      </>
    );
  };

  const scheduleFollowUpModalUi = () => (
    <Drawer
      open={showModalForScheduleFollowUp}
      anchor={"right"}
      PaperProps={{
        sx: {
          width: isMobile ? "100vw" : "30vw",
          overflow: "hidden",
        },
      }}
    >
      <div className="schedule-follow-up-cont">
        <div className="sfu-wrapper">
          <div className="sfu-header">
            <h4 id="contained-modal-title-vcenter">Schedule Follow-Up</h4>
            <div
              className="sfu-modal-header-close"
              onClick={handleCloseScheduleFollowModel}
            >
              <img
                src={close_icon}
                alt=""
                style={{
                  width: window.innerWidth > 767 ? "" : "26px",
                  height: window.innerWidth > 767 ? "" : "26px",
                }}
              />
            </div>
          </div>
          <div>
            <div className="sfu-modal-subtitle-body">
              <p className="header-subtitle">
                Patient will be informed about the follow-up appointment via SMS
              </p>
            </div>
            <Divider />
            <div
              className={
                enableLeadsDashboard
                  ? "sfu-modal-body"
                  : "sfu-modal-body-nowrap"
              }
            >
              {titleSubtitleUi("Patient Name", appointment?.patient_name)}
              {titleSubtitleUi("Mobile Number", appointment?.patient_phone_no)}
              {apponimentDateUi(
                "Appointment Date & Time",
                `${moment(appointment?.appointment_date).format(
                  "MMM DD, YYYY"
                )} at ${moment(
                  appointment?.appointment_start_time
                    ? appointment?.appointment_start_time
                    : followUpData?.Appointment_Time,
                  "hh:mmZ"
                ).format("hh:mm A")}`
              )}
              <div className="sfu-follow-up-date">
                <div className="sfu-title">Follow - Up Appointment Date</div>
                <div className="sfu-value">
                  {date ? (
                    moment(date).format("MMM DD, YYYY")
                  ) : (
                    <div
                      className={
                        !enableLeadsDashboard
                          ? "sfu-calendar"
                          : "sfu-calendar-row"
                      }
                    >
                      <Calendar
                        calenderDate={calenderDate}
                        setcalenderDate={setCalenderDate}
                      />
                    </div>
                  )}
                </div>
              </div>
              {enableLeadsDashboard && scheduleFollowUpPusposeProcedureUI()}
            </div>
          </div>
        </div>
        {scheduleFollowUpFooter()}
      </div>
    </Drawer>
  );

  return <div>{showModalForScheduleFollowUp && scheduleFollowUpModalUi()}</div>;
};

export default ScheduleFollowUpNewModal;
